<template>
  <v-navigation-drawer
    id="app-drawer"
    app
    dark
    floating
    persistent
    mobile-breakpoint="991"
    width="260"
  >
    <v-img :src="image" height="100%">
      <v-layout class="fill-height" tag="v-list" column>
        <v-list-item>
          <v-list-item-avatar>
            <v-img :src="logo" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title">
              KOBRA
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider />
        <v-list-item
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :active-class="color"
          avatar
          class="v-list-item"
        >
          <v-list-item-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title v-text="link.text" />
        </v-list-item>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "app-header",
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    logo: "favicon.ico",
    image: "/img/background.jpg",
    color: "#333",
    links: [
      {
        to: "/",
        icon: "mdi-view-dashboard",
        text: "Dashboard"
      },
      {
        to: "/orders",
        icon: "mdi-view-list",
        text: "Aufträge"
      },
      {
        to: "/customers",
        icon: "mdi-account-group",
        text: "Kunden"
      },
      {
        to: "/users",
        icon: "mdi-account",
        text: "Benutzer"
      },
      {
        to: "/settings",
        icon: "mdi-settings",
        text: "Einstellungen"
      }
    ]
  })
};
</script>
<style lang="scss" scoped>
#app-drawer {
  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }
}
</style>
